module.exports = __webpack_public_path__ + "img/x7.559fedf4.jpg";